export default __webpack_public_path__ + "static/poster-4d49b5b65e13cae51bb22dc4af8bb45e.png";